import React from "react";
import { queriesInternalAccounts } from "@query";
import { selectorActiveBankingAccount } from "../../../shared/selectors/selectorActiveBankingAccount";
import { FilterableTableInternalAccountTransactions } from "../components/TableInternalAccountTransactions/FilterableTableInternalAccountTransactions";

export const RouteTransactions: React.FC = () => {
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();

  const bankingAccount = queryInternalAccounts.data?.data?.find(
    selectorActiveBankingAccount
  );

  return (
    <FilterableTableInternalAccountTransactions
      internalAccountId={bankingAccount?.id}
    />
  );
};
